module.exports = __webpack_public_path__ + "img/hhht-605161.png";